import { call, put } from '@redux-saga/core/effects'
import axios from 'axios'
import { Action } from '../root'
import { playFileError } from '../../actions/files/actions'
import { playMsgFile } from '../../../api/files/playMsgFile'

export function* sagaPlayMsgFile({ payload }: Action<{ type: string; file: string }>) {
  try {
    yield call(playMsgFile, payload)
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(playFileError(error.response.data as unknown))
    } else {
      yield put(playFileError(error))
      throw error
    }
  }
}
